import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosConfig";
import { playlist } from "../../static/api";
import { notification } from "antd";

export const getPlaylists = createAsyncThunk(
  "playlist/getAll",
  async (_, thunkAPI) => {
    try {
      const res = await axiosInstance.get(playlist);
      return res.data;
    } catch (error) {
      const errorData = {
        message: error.message,
        response: error.response
          ? {
              status: error.response.status,
              data: error.response.data,
            }
          : null,
      };
      return thunkAPI.rejectWithValue({ error: errorData });
    }
  }
);

export const getPlaylist = createAsyncThunk(
  "playlist/getOne",
  async (id, thunkAPI) => {
    try {
      const res = await axiosInstance.get(`${playlist}/${id}`);
      return res.data;
    } catch (error) {
      const errorData = {
        message: error.message,
        response: error.response
          ? {
              status: error.response.status,
              data: error.response.data,
            }
          : null,
      };
      return thunkAPI.rejectWithValue({ error: errorData });
    }
  }
);

const initialState = {
  playlists: [],
  currentPlaylist: null,
  loading: false,
  detailLoading: false,
};

export const playlistSlice = createSlice({
  name: "playlist",
  initialState,
  reducers: {
    clearCurrentPlaylist: (state) => {
      state.currentPlaylist = null;
    },
    addPlaylistToList: (state, action) => {
      state.playlists = [action.payload, ...state.playlists];
    },
    removePlaylistFromList: (state, action) => {
      state.playlists = state.playlists.filter(
        (item) => item.id !== action.payload
      );
    },
    updatePlaylistInList: (state, action) => {
      const { id, ...updates } = action.payload;
      state.playlists = state.playlists.map((item) =>
        item.id === id ? { ...item, ...updates } : item
      );
    },
    setCurrentPlaylist: (state, action) => {
      state.currentPlaylist = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPlaylists.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPlaylists.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.playlists = payload;
    });
    builder.addCase(getPlaylists.rejected, (state, { payload }) => {
      state.loading = false;
      const msg =
        payload?.error?.response?.data?.message ||
        payload?.error?.message ||
        "Failed to load playlists";
      notification.error({
        message: "Error loading playlists",
        description: msg,
      });
    });
    builder.addCase(getPlaylist.pending, (state) => {
      state.detailLoading = true;
    });
    builder.addCase(getPlaylist.fulfilled, (state, { payload }) => {
      state.detailLoading = false;
      state.currentPlaylist = payload;
    });
    builder.addCase(getPlaylist.rejected, (state, { payload }) => {
      state.detailLoading = false;
      const msg =
        payload?.error?.response?.data?.message ||
        payload?.error?.message ||
        "Failed to load playlist";
      notification.error({
        message: "Error loading playlist",
        description: msg,
      });
    });
  },
});

export const {
  clearCurrentPlaylist,
  addPlaylistToList,
  removePlaylistFromList,
  updatePlaylistInList,
  setCurrentPlaylist,
} = playlistSlice.actions;

export default playlistSlice.reducer;
